import React, { useState } from "react";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import Button from "../components/Button/Button";
import { PostCreateExam } from "../services/services";
// import {useToasts} from "react-toast-notifications";
import { FixNumbers } from "../constants/api/api";

const AddQuestion = () => {
  // const [selectedDay, setSelectedDay] = useState({
  //   timeS: "",
  //   dateS: null,
  //   timeE: "",
  //   dateE: null,
  // });
  // const [trueAnswer, setTrueAnswer] = useState({
  //   one: false,
  //   two: false,
  //   three: false,
  // });
  // const [question, setQuestion] = useState({});
  // // const {addToast} = useToasts();
  // const SndToServer = () => {
  //   if (
  //     !!question &&
  //     !!question.TimeToAnswer &&
  //     !!question.TimeToAnswer2 &&
  //     !!question.TimeToAnswer3 &&
  //     !!selectedDay.timeS &&
  //     !!selectedDay.timeE &&
  //     !!selectedDay.dateS &&
  //     !!selectedDay.dateE
  //   ) {
  //     const body = {
  //       ExamContent: {
  //         Name: question?.QuestionContent,
  //         BeginDate:
  //           selectedDay.dateS.year +
  //           "-" +
  //           selectedDay.dateS.month +
  //           "-" +
  //           selectedDay.dateS.day +
  //           " " +
  //           selectedDay.timeS,
  //         EndDate:
  //           selectedDay.dateE.year +
  //           "-" +
  //           selectedDay.dateE.month +
  //           "-" +
  //           selectedDay.dateE.day +
  //           " " +
  //           selectedDay.timeE,
  //       },
  //       Questions: [
  //         {
  //           QuestionContent: question?.question,
  //           TimeToAnswer: parseInt(FixNumbers(question.TimeToAnswer)),
  //           PossibleAnswers: [
  //             {
  //               AnswerContent: question?.option1,
  //               IsTrue: trueAnswer.one === "option1",
  //             },
  //             {
  //               AnswerContent: question?.option2,
  //               IsTrue: trueAnswer.one === "option2",
  //             },
  //             {
  //               AnswerContent: question?.option3,
  //               IsTrue: trueAnswer.one === "option3",
  //             },
  //             {
  //               AnswerContent: question?.option4,
  //               IsTrue: trueAnswer.one === "option4",
  //             },
  //           ],
  //         },
  //         {
  //           QuestionContent: question?.question2,
  //           TimeToAnswer: parseInt(FixNumbers(question.TimeToAnswer2)),
  //           PossibleAnswers: [
  //             {
  //               AnswerContent: question?.option5,
  //               IsTrue: trueAnswer.two === "option5",
  //             },
  //             {
  //               AnswerContent: question?.option6,
  //               IsTrue: trueAnswer.two === "option6",
  //             },
  //             {
  //               AnswerContent: question?.option7,
  //               IsTrue: trueAnswer.two === "option7",
  //             },
  //             {
  //               AnswerContent: question?.option8,
  //               IsTrue: trueAnswer.two === "option8",
  //             },
  //           ],
  //         },
  //         {
  //           QuestionContent: question?.question3,
  //           TimeToAnswer: parseInt(FixNumbers(question?.TimeToAnswer3)),
  //           PossibleAnswers: [
  //             {
  //               AnswerContent: question?.option9,
  //               IsTrue: trueAnswer.three === "option9",
  //             },
  //             {
  //               AnswerContent: question?.option10,
  //               IsTrue: trueAnswer.three === "option10",
  //             },
  //             {
  //               AnswerContent: question?.option11,
  //               IsTrue: trueAnswer.three === "option11",
  //             },
  //             {
  //               AnswerContent: question?.option12,
  //               IsTrue: trueAnswer.three === "option12",
  //             },
  //           ],
  //         },
  //       ],
  //     };
  //     console.log(body);
  //     PostCreateExam(body).then((response) => {
  //       console.log(response);
  //       if (response.data.errorCode === 200) {
  //         // addToast('با موفقیت ثبت شد', {appearance: 'success'});
  //       } else {
  //         // addToast(response.data.message, {appearance: 'error'});
  //       }
  //     });
  //   }
  // };
  return (
    <div className="AddQuestion container-fluid mt-5">
      {/* <h2 className="text-light mb-5">افزودن سوال</h2>
      <div className="d-flex justify-content-center">
        <input
          type="text"
          className={"w-25"}
          value={!!selectedDay ? selectedDay.QuestionContent : ""}
          onChange={(e) =>
            setQuestion({ ...selectedDay, QuestionContent: e.target.value })
          }
          placeholder="نام آزمون"
        />
      </div>
      <p className="text-center mb-0">زمان شروع</p>
      <div className="AddQuestion-time">
        <DatePicker
          inputClassName={"form-control"}
          value={selectedDay.dateS}
          onChange={(e) => setSelectedDay({ ...selectedDay, dateS: e })}
          inputPlaceholder="تاریخ "
          locale="fa"
          shouldHighlightWeekends
        />
        <input
          type="text"
          value={!!selectedDay ? selectedDay.timeS : ""}
          onChange={(e) =>
            setSelectedDay({ ...selectedDay, timeS: e.target.value })
          }
          placeholder="ساعت (۲۴ ساعته)21:30"
        />
      </div>
      <p className="text-center mb-0 mt-2">زمان پایان</p>
      <div className="AddQuestion-time">
        <DatePicker
          inputClassName={"form-control"}
          value={selectedDay.dateE}
          onChange={(e) => setSelectedDay({ ...selectedDay, dateE: e })}
          inputPlaceholder="تاریخ "
          locale="fa"
          shouldHighlightWeekends
        />
        <input
          type="text"
          value={!!selectedDay ? selectedDay.timeE : ""}
          onChange={(e) =>
            setSelectedDay({ ...selectedDay, timeE: e.target.value })
          }
          placeholder="ساعت (۲۴ ساعته)21:30"
        />
      </div>
      <div className="question">
        <textarea
          name=""
          id="question"
          cols="30"
          rows="10"
          placeholder={"سوال"}
          value={!!question.question ? question.question : ""}
          onChange={(e) =>
            setQuestion({ ...question, question: e.target.value })
          }
        >
          {" "}
        </textarea>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 1"}
            value={!!question.option1 ? question.option1 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option1: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, one: "option1" })}
            type="radio"
            id="html"
            name="address"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 2"}
            value={!!question.option2 ? question.option2 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option2: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, one: "option2" })}
            type="radio"
            id="html"
            name="address"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 3"}
            value={!!question.option3 ? question.option3 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option3: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, one: "option3" })}
            type="radio"
            id="html"
            name="address"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 4"}
            value={!!question.option4 ? question.option4 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option4: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, one: "option4" })}
            type="radio"
            id="html"
            name="address"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <input
          type="tel"
          placeholder={"زمان پاسخ به این سوال"}
          onChange={(e) =>
            setQuestion({ ...question, TimeToAnswer: e.target.value })
          }
        />
      </div>

      <div className="question">
        <textarea
          name=""
          id="question"
          cols="30"
          rows="10"
          placeholder={"سوال"}
          value={!!question.question2 ? question.question2 : ""}
          onChange={(e) =>
            setQuestion({ ...question, question2: e.target.value })
          }
        >
          {" "}
        </textarea>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 1"}
            value={!!question.option5 ? question.option5 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option5: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, two: "option5" })}
            type="radio"
            id="html"
            name="addresss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 2"}
            value={!!question.option6 ? question.option6 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option6: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, two: "option6" })}
            type="radio"
            id="html"
            name="addresss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 3"}
            value={!!question.option7 ? question.option7 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option7: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, two: "option7" })}
            type="radio"
            id="html"
            name="addresss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 4"}
            value={!!question.option8 ? question.option8 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option8: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, two: "option8" })}
            type="radio"
            id="html"
            name="addresss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <input
          type="tel"
          placeholder={"زمان پاسخ به این سوال"}
          onChange={(e) =>
            setQuestion({ ...question, TimeToAnswer2: e.target.value })
          }
        />
      </div>

      <div className="question">
        <textarea
          name=""
          id="question"
          cols="30"
          rows="10"
          placeholder={"سوال"}
          value={!!question.question3 ? question.question3 : ""}
          onChange={(e) =>
            setQuestion({ ...question, question3: e.target.value })
          }
        >
          {" "}
        </textarea>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 1"}
            value={!!question.option9 ? question.option9 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option9: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) => setTrueAnswer({ ...trueAnswer, three: "option9" })}
            type="radio"
            id="html"
            name="addressss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 2"}
            value={!!question.option10 ? question.option10 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option10: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) =>
              setTrueAnswer({ ...trueAnswer, three: "option10" })
            }
            type="radio"
            id="html"
            name="addressss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 3"}
            value={!!question.option11 ? question.option11 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option11: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) =>
              setTrueAnswer({ ...trueAnswer, three: "option11" })
            }
            type="radio"
            id="html"
            name="addressss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <div className="d-flex flex-row-reverse align-items-center">
          <textarea
            name=""
            id="answer"
            cols="30"
            rows="4"
            placeholder={"گزینه 4"}
            value={!!question.option12 ? question.option12 : ""}
            onChange={(e) =>
              setQuestion({ ...question, option12: e.target.value })
            }
          >
            {" "}
          </textarea>
          <input
            onChange={(e) =>
              setTrueAnswer({ ...trueAnswer, three: "option12" })
            }
            type="radio"
            id="html"
            name="addressss"
            style={{ width: 20, marginLeft: 5 }}
          />
        </div>

        <input
          type="tel"
          placeholder={"زمان پاسخ به این سوال"}
          onChange={(e) =>
            setQuestion({ ...question, TimeToAnswer3: e.target.value })
          }
        />
      </div>

      <div className="d-flex justify-content-center">
        <Button onClick={() => SndToServer()} className="third-button">
          ارسال
        </Button>
      </div> */}
    </div>
  );
};

export default AddQuestion;
